module.exports = "/images/no-break-types.svg?0cf30a91da6abde4cc5fe37c44a65083";